import type Board from "./board";
import Card from "./card";
import Chair from "./chair";

export type TrickType = {
    cards: Card[] // the cards of the trick in order of play
    winner: Chair
    first: Chair // the chair of who started the trick
}

export default class Trick implements TrickType {
    cards: Card[] = []
    winner: Chair = new Chair()
    first: Chair = new Chair()

    static fromObject(o: any, fromBoard: Board) {
        const t = new Trick();

        t.winner.set(o.winner);
        t.first.set(o.first);

        const turn = t.first.clone();

        for (const c of o.cards) {
            const cobj = Card.fromObject(c)
            const card = fromBoard?.getCardToPlay(cobj, turn) ?? cobj;
            t.cards.push(card);
            turn.setNext();
        }
        return t;
    }

    reset() {
        this.first.setNone();
        this.winner.setNone();
        this.cards.splice(0);
    }

    // checks if there's a valid card in the trick
    isValid(): boolean {
        // TODO
        return this.cards.length > 0 && this.cards[0].isValid() /* && this.first.isPlayer()*/;
    }

    calcWinner(trump: number) {
        if (this.cards.length === 4 && this.isValid()) {
            let highestCard = this.cards[0];
            let askedSuit = highestCard.suit;
            let isHighestATrump = askedSuit == trump;

            for (const card of this.cards) {
                // check when card is trump itself..
                if (card.suit === trump) {
                    if (isHighestATrump) {
                        if (card.higherThan(highestCard)) {
                            // the lower the card the higher                             
                            // the value (SA = 1, C2 = 52)
                            highestCard = card;
                        }
                    } else {
                        highestCard = card;
                        isHighestATrump = true;
                    }
                } else if (!isHighestATrump) {
                    if (card.suit == askedSuit) {
                        if (card.higherThan(highestCard)) {
                            // the lower the card the higher
                            highestCard = card;
                        }
                    }
                }
            }

            let highestIdx = this.getIndex(highestCard);
            this.winner.set(this.first.plus(new Chair().setInt(highestIdx)));
            return highestIdx;
        } else {
            return -1;
        }
    }

    getIndex(card: Card) {
        let index = -1;

        for (let i = 0; i < this.cards.length; i++) {
            if (this.cards[i].equals(card)) {
                index = i;
                break;
            }
        }
        return index;
    }
}